import { type FC } from "react";

import { useLensIdSearchParameter } from "../../hooks";

import { QualifiedLensPlaysSection } from "./QualifiedLensPlaysSection";
import { RetentionSection } from "./RetentionSection";
import { TopLensesSection } from "./top-lenses";

export const AdditionalInsights: FC = () => {
    const { lensId } = useLensIdSearchParameter();

    if (!lensId) {
        return <TopLensesSection />;
    }

    return (
        <>
            <QualifiedLensPlaysSection />
            <RetentionSection />
        </>
    );
};
